module.exports = __webpack_public_path__ + "static/media/resturant-menu-theme-2.1adc27ae.jpg";